import React, { useState, useEffect } from 'react';
import CustomNavbar from '../components/Navbar';
import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';


const NotFound = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const userId = localStorage.getItem('user_id');
        if (userId) {
            setIsLoggedIn(true);
        }
    }, []);

    return (
        <div style={{ fontFamily: 'Calibri, sans-serif', textAlign: 'center', height: '100vh', display: 'flex', flexDirection: 'column' }}>
            {isLoggedIn && <CustomNavbar onNavbarReady={() => {}} />}
            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Result
                    status="404"
                    title={<span style={{ fontSize: '2rem' }}>404 Not Found</span>}
                    subTitle={<span style={{ fontSize: '1.5rem' }}>Sorry, the page you visited does not exist.</span>}
                    extra={
                        <Button type="primary" style={{ fontSize: '1.2rem', padding: '20px' }}>
                            <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>Back Home</Link>
                        </Button>
                    }
                />
            </div>
        </div>
    );
};

export default NotFound;